import { render, staticRenderFns } from "./reilulaina.vue?vue&type=template&id=371b1dda&"
import script from "./reilulaina.vue?vue&type=script&lang=js&"
export * from "./reilulaina.vue?vue&type=script&lang=js&"
import style0 from "./reilulaina.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports